// const jsdom = require("jsdom");
// const {JSDOM} = jsdom;
// import store from '../data/store'

function getCaption() {
  return "Ultimate Guitar Search"
}

function getIcon() {
  return "images/menu/ultimate-guitar-logo.png"
}

function process() {
  // const url = 'https%3A%2F%2Fwww.ultimate-guitar.com%2Fsearch.php%3Ftitle%3Dthe+spirit+of+radio'
  // return getUgData(url).then(json => {
  //  
  //   return getUgChart({title: 'the spirit of radio'})
  //   JSDOM.fromURL('http://www.quickchords.org:9999/rest/qc/proxy?url=' + url, {})
  //     .then(dom => {
  //       setTimeout(() => {
  //         const content = dom.window.document.body.innerHTML
  //         const rx = /window\.UGAPP\.store\.page = (.*);\n/
  //         const m = rx.exec(content)
  //         if (m) {
  //           const data = JSON.parse(m[1])
  //           console.log(data)
  //           return resolve(data)
  //         } else {
  //           reject(new Error("Data not found"))
  //         }
  //       }, 1000)
  //     }).catch(reason => reject(reason));
  return Promise.reject(new Error('Not implemented'))
}

function getUgTabText(proxyUrl, url) {
  return getUgData(proxyUrl, url).then(json => json.data.tab_view.wiki_tab.content);
}

function getUgSearchUrl(options) {
  if (!options.title) {
    return ''
  }
  let url = `https://www.ultimate-guitar.com/search.php?search_type=title&value=${encodeURIComponent(options.title)}`
  if (options.artist) {
    url += encodeURIComponent(` by ${options.artist}`)
  }
  return url
}

function getUgSearch(options) {
  let ugSearchUrl = getUgSearchUrl(options);
  if (!ugSearchUrl) {
    return Promise.reject(new Error('no title provided for search'))
  }
  return getUgData(options.proxyUrl, ugSearchUrl).then(json => json.data.results)
}

/**
 * Gets the parsed data from the script tag on the page
 * @param url
 * @returns {Promise<Object>}
 */
function getUgData(proxyUrl, url) {
  return new Promise((resolve, reject) => {
    var proxy = `${proxyUrl}/rest/qc/proxy?url=${encodeURIComponent(url)}`
    fetch(proxy)
      .then(res => res.text())
      .then(text => {
        const rx = /window\.UGAPP\.store\.page = (.*);\n/
        const m = rx.exec(text)
        if (m) {
          const data = JSON.parse(m[1])
          //console.log(data)
          return resolve(data)
        } else {
          resolve([])
        }
      }).catch(reason => resolve(reason))

    // JSDOM.fromURL(proxy)
    //   .then(dom => {
    //     setTimeout(() => {
    //       const content = dom.window.document.body.innerHTML
    //       const rx = /window\.UGAPP\.store\.page = (.*);\n/
    //       const m = rx.exec(content)
    //       if (m) {
    //         const data = JSON.parse(m[1])
    //         console.log(data)
    //         return resolve(data)
    //       } else {
    //         reject(new Error("Data not found in document"))
    //       }
    //     }, 500)
    //   }).catch(reason => reject(reason));
  });
}

export {getCaption, getIcon, process, getUgData, getUgSearch, getUgTabText, getUgSearchUrl}